module.exports = __webpack_public_path__ + "img/15-doc-implantar-lista.350aa7ae.png";